import React from 'react';

import { withStyles } from '@mui/styles';

import {
  Fab,
  Icon,
  List,
  Paper,
  Drawer,
  Button,
  Select,
  Divider,
  MenuItem,
  ListItem,
  TextField,
  InputLabel,
  FormControl,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';

class UserMenuEdit extends ComponentWrapper {
  state = {
    user_menu: {
      menu: [
        {
          title: '',
          buttons: [
            {
              title: 'Link title',
              url: '/linkurl',
              icon: 'star',
            },
          ],
        },
      ],
      group: [],
    },
    groups: [],
  };

  UNSAFE_componentWillMount() {
    this.setState({
      user_menu: this.props.userMenu,
      groups: this.props.groups,
    });
  }

  // getAdditionalInfo = () => { //it is broken, course in `/meta_query?meta_query=["setup_accounts_tbox"]` changed data format
  //   this.get({
  //     url: `/meta_query?meta_query=["setup_accounts_tbox"]`,
  //     cb: (res) => {
  //       const { setup_accounts_tbox } = res._meta_query;

  //       this.setState({ accountGroups: setup_accounts_tbox });
  //     },
  //   });
  // };

  toggleDrawer = () => {
    this.setState({ drawerIsOpen: !this.state.drawerIsOpen });
  };

  getMenuList = () => {
    const { menu } = this.state.user_menu;
    const { classes } = this.props;

    return menu.map((menuArr, menuArrIndex) => {
      return (
        <div key={menuArrIndex}>
          <List style={{ paddingTop: '5px', paddingBottom: '5px' }}>
            {menuArr.title ? <div className={classes.menuHeading}>{menuArr.title}</div> : null}

            {menuArr.buttons.map((menuItem, menuItemIndex) => {
              return (
                <a
                  key={menuItemIndex}
                  href={menuItem.url}
                  className={classes.pointer}
                  style={{
                    display: 'flex',
                  }}
                >
                  <ListItem
                    style={{
                      height: '38px',
                      paddingLeft: '24px',
                      paddingRight: '24px',
                      border: 'none',
                    }}
                    button
                    // onClick={this.toggleDrawer}
                  >
                    {menuItem.icon ? (
                      <ListItemIcon style={{ marginRight: '22px' }}>
                        <Icon>{menuItem.icon}</Icon>
                      </ListItemIcon>
                    ) : (
                      <div style={{ width: '46px' }} />
                    )}
                    <ListItemText style={{ padding: '0' }} primary={menuItem.title} />
                  </ListItem>
                </a>
              );
            })}
          </List>
          <Divider light/>
        </div>
      );
    });
  };

  addGroup = () => {
    const { user_menu } = this.state;

    user_menu.menu.push({
      buttons: [],
      title: '',
    });

    this.setState({ user_menu });
  };

  addLink = (menuArrIndex) => {
    const { user_menu } = this.state;

    user_menu.menu[menuArrIndex].buttons.push({
      title: '',
      url: '',
      icon: '',
    });

    this.setState({ user_menu });
  };

  onLinkEdit = (menuArrIndex, linkIndex, field, value) => {
    const { user_menu } = this.state;

    user_menu.menu[menuArrIndex].buttons[linkIndex][field] = value;

    this.setState({ user_menu });
  };

  removeGroupLink = (menuArrIndex, linkIndex) => {
    const { user_menu } = this.state;

    user_menu.menu[menuArrIndex].buttons.splice(linkIndex, 1);

    this.setState({ user_menu });
  };

  onSaveMenuClick = () => {
    const { user_menu } = this.state;

    this.postWithData({
      url: '/rest/upd_jel?type=user_menu',
      data: user_menu,
      cb: (res) => {
        this.setState({ user_menu: res.user_menu });
      },
    });
  };

  render() {
    const { classes } = this.props;
    const { user_menu, groups } = this.state;

    const selectClassNames = {
      select: classes.trplSelect,
      icon: classes.trplSelectIcon,
      root: classes.trplSelectContainer,
    };

    const menuProps = {
      classes: {
        paper: classes.trplSelectMenu,
      },
    };

    const itemStyles = {
      minHeight: '24px',
      lineHeight: 'normal',
      fontSize: '12px',
      padding: '0 16px',
    };

    return (
      <div className={classes.wrapper}>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.drawer,
          }}
          variant="permanent"
          onClose={this.toggleDrawer}
          open={this.state.drawerIsOpen}
        >
          <div tabIndex={0} role="button">
            {user_menu.menu.length ? this.getMenuList() : null}
          </div>
        </Drawer>

        <div
          style={{
            paddingLeft: '250px',
            paddingTop: '50px',
            paddingRight: '50px',
          }}
        >
          <Paper className={classes.container}>
            <div className={`${classes.mb10} ${classes.alignCenter}`}>
              <TextField
                label="Title"
                className={classes.mr10}
                value={user_menu.title || ''}
                onChange={(e) => {
                  const { user_menu } = this.state;

                  user_menu.title = e.target.value;

                  this.setState({ user_menu });
                }}
              />

              <FormControl margin="none">
                <InputLabel>Account group</InputLabel>
                <Select
                  multiple
                  fullWidth
                  MenuProps={menuProps}
                  className={classes.w200}
                  classes={selectClassNames}
                  value={user_menu.group || []}
                  onChange={(e) => {
                    const { user_menu } = this.state;

                    if (e.target.value.includes('reset')) {
                      delete user_menu.group;
                    } else {
                      user_menu.group = e.target.value;
                    }

                    this.setState({ user_menu });
                  }}
                >
                  <MenuItem style={itemStyles} value="reset" />

                  {groups.map((group, groupIndex) => (
                    <MenuItem value={group.id} key={groupIndex} style={itemStyles}>
                      {group.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {user_menu.menu.map((menuArr, menuArrIndex) => {
              return (
                <div
                  style={{
                    padding: '10px',
                    border: '1px solid #ccc',
                  }}
                  key={menuArrIndex}
                  className={classes.mb10}
                >
                  {menuArr.buttons.map((link, linkIndex) => {
                    return (
                      <div className={`${classes.alignCenter} ${classes.mb10}`} key={linkIndex}>
                        <TextField
                          className={classes.mr10}
                          onChange={(e) => {
                            this.onLinkEdit(menuArrIndex, linkIndex, 'title', e.target.value);
                          }}
                          label="Title"
                          value={link.title}
                        />
                        <TextField
                          className={classes.mr10}
                          onChange={(e) => {
                            this.onLinkEdit(menuArrIndex, linkIndex, 'url', e.target.value);
                          }}
                          label="Url"
                          value={link.url}
                        />
                        <TextField
                          className={classes.mr10}
                          onChange={(e) => {
                            this.onLinkEdit(menuArrIndex, linkIndex, 'icon', e.target.value);
                          }}
                          label="Icon"
                          value={link.icon}
                        />

                        <Fab
                          size="small"
                          color="secondary"
                          variant="circular"
                          onClick={() => this.removeGroupLink(menuArrIndex, linkIndex)}
                          style={{
                            flexShrink: '0',
                            zoom: '0.8',
                          }}
                        >
                          <Icon>delete</Icon>{' '}
                        </Fab>
                      </div>
                    );
                  })}

                  <Button size="small" variant="contained" onClick={() => this.addLink(menuArrIndex)}>
                    Add link
                  </Button>
                </div>
              );
            })}

            <div className={`${classes.mb10} ${classes.justifyEnd}`}>
              <Button size="small" variant="contained" onClick={this.addGroup}>
                Add group
              </Button>
            </div>

            <div className={`${classes.mb10} ${classes.justifyEnd}`}>
              <Button size="small" color="primary" variant="contained" onClick={this.onSaveMenuClick}>
                Save
              </Button>
            </div>
          </Paper>
        </div>
      </div>
    );
  }
}

const styles = {
  header: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    background: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.02)',
    zIndex: '999',
  },
  burgerIconContainer: {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mwLogo: {
    width: '40px',
    height: '40px',
    display: 'flex',
    color: '#A285C5',
    fontSize: '18px',
    fontWeight: '300',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuItem: {},
  menuHeading: {
    height: '35px',
    display: 'flex',
    fontSize: '18px',
    color: '#4E4C4C',
    fontWeight: '600',
    lineHeight: '25px',
    fontStyle: 'normal',
    textAlign: 'center',
    paddingLeft: '24px',
    alignItems: 'center',
  },
  account: {
    fontSize: '12px',
    padding: '0 30px',
  },
  content: {
    paddingTop: '50px',
  },
  drawer: {
    top: '50px',
  },
  ...CommonStyles,
};

export default withStyles(styles)(UserMenuEdit);
